'use client'

import { Dictionary } from '@/localization/dictionary'
import LoginForm, { LoginFormVariant } from './login-form'
import ForgotPassword from './forgot-password'
import { ReactNode, useState } from 'react'
import { useRouter } from 'next/navigation'

interface LoginFormWrapperProps {
  dict: Pick<Dictionary, 'loginForm' | 'forgotPasswordForm'>
  onSuccess?: () => void
  title: ReactNode
  register?: ReactNode
  redirectTo?: string
  variant?: LoginFormVariant
}

const LoginFormWrapper = ({
  dict,
  onSuccess,
  title,
  register,
  redirectTo,
  variant,
}: LoginFormWrapperProps) => {
  const [showLogin, setShowLogin] = useState(true)
  const router = useRouter()

  return (
    <>
      {showLogin ? (
        <LoginForm
          title={title}
          register={register}
          variant={variant}
          refreshPageAfterLogin={!redirectTo}
          dict={dict.loginForm}
          onForgotPassword={() => setShowLogin(false)}
          onSuccess={() =>
            redirectTo ? router.push(redirectTo) : onSuccess?.()
          }
        />
      ) : (
        <ForgotPassword
          onBackToLogin={() => setShowLogin(true)}
          dict={dict.forgotPasswordForm}
        />
      )}
    </>
  )
}

export default LoginFormWrapper
